import styles from './Thumbnail.module.css';

export type ThumbnailProps = {
  src: string | null;
  alt: string;
  placeholder?: string | null | undefined;
  size?: 'sm' | 'md' | 'lg' | 'fill';
};

const PIXELS = { sm: 40, md: 96, lg: 320, fill: 640 } as const;

const SAFE_PLACEHOLDER = /^data:image\/webp;base64,[A-Za-z0-9+/]+={0,2}$/u;

const backgroundOf = (placeholder: string | null) =>
  placeholder !== null && SAFE_PLACEHOLDER.test(placeholder)
    ? { backgroundImage: `url("${placeholder}")` }
    : undefined;

export const Thumbnail = ({ src, alt, placeholder = null, size = 'md' }: ThumbnailProps) => (
  <span className={[styles['frame'], styles[size]].join(' ')} style={backgroundOf(placeholder)}>
    {src === null ? (
      <span
        className={styles['empty']}
        {...(alt === '' ? { 'aria-hidden': true } : { role: 'img', 'aria-label': alt })}
      />
    ) : (
      <img
        className={styles['image']}
        src={src}
        alt={alt}
        width={PIXELS[size]}
        height={PIXELS[size]}
        loading="lazy"
        decoding="async"
      />
    )}
  </span>
);
